// extracted by css-extract-rspack-plugin
export default {"cls1":"TasteOfMentionsHeader-cls1_Pbb","cls2":"TasteOfMentionsHeader-cls2_qG4 TasteOfMentionsHeader-cls1_Pbb"};